module.exports = __webpack_public_path__ + "media/images/background-4369b86c0794f0553a6fe2468302263b.png";